import React, { useEffect, useRef, useState } from "react";
import { ArrowBackIos, ArrowForwardIos } from "@material-ui/icons";
import { Button, Divider, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import './styles.css';

const Calendar = (props) => {
	const { t } = useTranslation();

	const backgroundColor = props?.backgroundColor;
	const selectedColor = props?.color || "#672E37";
	const selectedDate = props?.date ? new Date(props?.date) : new Date(Date.now());
	const [actualDate, setActualDate] = useState(selectedDate);
	const todayDate = new Date();
	const { onChange, setDate, style, daysToNotify, availableDates } = props;
	const daysOfWeek = [t("Sun"), t("Mon"), t("Tues"), t("Wed"), t("Thurs"), t("Fri"), t("Sat")];
	const dayRef = useRef(null);

	const convertMonth = (month) => {
		switch (month) {
			case 0:
				return t("January");
			case 1:
				return t("February");
			case 2:
				return t("March");
			case 3:
				return t("April");
			case 4:
				return t("May");
			case 5:
				return t("June");
			case 6:
				return t("July");
			case 7:
				return t("August");
			case 8:
				return t("September");
			case 9:
				return t("October");
			case 10:
				return t("November");
			case 11:
				return t("December");
		}
	};

	const convertDayOfWeek = (day) => {
		switch (day) {
			case 0:
				return t("Sunday");
			case 1:
				return t("Monday");
			case 2:
				return t("Tuesday");
			case 3:
				return t("Wednesday");
			case 4:
				return t("Thursday");
			case 5:
				return t("Friday");
			case 6:
				return t("Saturday");
		}
	};

	const getDaysOfMounth = () => {
		let days = [[], [], [], [], [], []];
		let fristDay = new Date(actualDate.getFullYear(), actualDate.getMonth(), 1);
		let lastDay = new Date(actualDate.getFullYear(), actualDate.getMonth() + 1, 0).getDate();

		let j = 0;

		for (var i = 0; i < fristDay.getDay(); i++) {
			days[j].push(null);
			if (days[j].length == 7 && j < 5) {
				j++;
			}
		}

		for (var i = 1; i <= lastDay; i++) {
			days[j].push(i);
			if (days[j].length == 7 && j < 5) {
				j++;
			}
		}

		const remainingLength = 42 - lastDay - fristDay.getDay();

		for (var i = 0; i < remainingLength; i++) {
			days[j].push(null);
			if (days[j].length == 7 && j < 5) {
				j++;
			}
		}

		return days;
	};

	const [daysOfMonth, setDaysOfMonth] = useState(() => getDaysOfMounth());

	const nextMonth = () => {
		if (actualDate.getMonth() == 11) {
			setActualDate(new Date(actualDate.getFullYear() + 1, 0, 1));
		} else {
			setActualDate(new Date(actualDate.getFullYear(), actualDate.getMonth() + 1, 1));
		}
	};

	const prevMonth = () => {
		if (actualDate.getMonth() == 0) {
			setActualDate(new Date(actualDate.getFullYear() - 1, 11, 1));
		} else {
			setActualDate(new Date(actualDate.getFullYear(), actualDate.getMonth() - 1, 1));
		}
	};

	useEffect(() => {
		setDaysOfMonth(getDaysOfMounth(actualDate.getMonth()));
	}, [actualDate]);

	const haveNotificationTo = (day) => {
		for (let i = 0; i < daysToNotify.length; i++) {
			let notifyDate = new Date(daysToNotify[i]);
			if (
				notifyDate.getDate() + 1 == day &&
				notifyDate.getMonth() == actualDate.getMonth() &&
				notifyDate.getFullYear() == actualDate.getFullYear()
			) {
				return true;
			}
		}
		return false;
	};

	const available = (day) => {
		if (!availableDates || !day) {
			return false;
		}
		let dateAvailable =
			actualDate.getFullYear() +
			"-" +
			(actualDate.getMonth() + 1 <= 9 ? "0" : "") +
			(actualDate.getMonth() + 1) +
			"-" +
			(day <= 9 ? "0" : "") +
			day;
		for (let i = 0; i < availableDates?.length; i++) {
			if (dateAvailable == availableDates[i]) {
				return true;
			}
		}
		return false;
	};

	return (
		<div style={style}>
			<div style={{ display: "flex", justifyContent: "center" }}>
				<div>
					<div
						style={{
							backgroundColor: backgroundColor,
							display: "flex",
							flexDirection: "column",
						}}>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								alignSelf: "center",
							}}>
							<ArrowBackIos
								onClick={prevMonth}
								style={{
									color: selectedColor,
									width: "18px",
									border: "none",
									backgroundColor: "none",
									color: "#222222",
								}}></ArrowBackIos>

							<Typography
								style={{
									color: "#222222",
									textAlign: "center",
									fontSize: "28px",
									width: "80vw",
									maxWidth: "260px",
									fontWeight: "800",
									letterSpacing: "-2px"
								}}>
								{`${convertMonth(actualDate.getMonth())} ${actualDate.getFullYear()}`}
							</Typography>
							
							<ArrowBackIos
								onClick={nextMonth}
								style={{
									color: selectedColor,
									width: "18px",
									border: "none",
									backgroundColor: "none",
									color: "#222222",
									transform: 'rotate(180deg)'
							}}></ArrowBackIos>
						</div>
						<div className="notranslate"
							style={{
								display: "flex",
								justifyContent: "space-between",
								margin: "10px 0",
								width: "80vw",
								maxWidth: "320px",
								alignSelf: "center",
							}}>
							{daysOfWeek.map((day) => {
								return (
									<Typography
										style={{
											color: "#222",
											fontSize: "18px",
										}}>
										{day}
									</Typography>
								);
							})}
						</div>
						<div style={{ height: "1px", flex: 1, backgroundColor: "lightgray" }}></div>
					</div>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							margin: "10px 0",
							alignSelf: "center",
						}}>
						<div style={{ height: "200px" }}>
							{daysOfMonth.map((week) => {
								return (
									<div
										style={{
											marginTop: "10px",
											display: "flex",
											justifyContent: "space-between",

											margin: "10px 0",
											width: "80vw",
											maxWidth: "320px",
										}}>
										{week.map((day) => {
											let isAvailable = available(day);
											const isToday =
												day !== null &&
												day === todayDate.getDate() &&
												actualDate.getMonth() === todayDate.getMonth() &&
												actualDate.getFullYear() === todayDate.getFullYear();
											const isSelected =
												props?.date &&
												selectedDate.getDate() == day &&
												selectedDate.getMonth() == actualDate.getMonth() &&
												selectedDate.getFullYear() == actualDate.getFullYear();
											const handleDayClick = (event) => {
												const target = event.currentTarget;
												target.classList.remove('shake');
												void target.offsetWidth;
												target.classList.add('shake');
											
												if (day != null && isAvailable) {
												return;
												  setDate(new Date(actualDate.getFullYear(), actualDate.getMonth(), day));
												  if (onChange) {
													onChange(); 
												  }
											}
											}
											return (
												<>
													<Typography
														ref={dayRef}
														data-today={isToday ? "true" : undefined}
														onClick={(e) => {
															if (day != null && isAvailable) {
																handleDayClick(e);
																setDate(new Date(actualDate.getFullYear(), actualDate.getMonth(), day));
																if (onChange) {
																	onChange();
																}
															}
														}}
														style={{
															width: "30px",
															height: "30px",
															display: "flex",
															color:
																isSelected
																	? "white"
																	: !isAvailable
																	? "#cccccc"
																	: (!selectedColor ? "rgba(255,255,255,0.8)" : "#222"),
															fontSize: "18px",
															padding: "8px",
															justifyContent: "center",
															alignItems: "center",
															backgroundColor: isSelected ? selectedColor : "transparent",
															borderRadius: "80px",
															border: isToday && !isSelected ? `2px solid ${selectedColor}` : "none",
															textDecorationLine: !isAvailable ? "line-through" : "none",
														}}>
														{day}
													</Typography>
													{daysToNotify?.length > 0 && haveNotificationTo(day) && (
														<div
															style={{
																backgroundColor: "#3689ea",
																width: "10px",
																height: "10px",
																borderRadius: "30px",
																position: "relative",
																top: "70px",
																right: "76px",
															}}></div>
													)}
												</>
											);
										})}
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Calendar;
